<template>
   <div>
     {{ deduct_category_name }}
   </div>
</template>

<script>
import i18n from '../../../../locales/index'

export default {
  name: 'ScopeShop',
  components: {},
  data () {
    return {
      deduct_category_name: i18n.t('pages_deduct_coupon_rule_components_scopeofuse_shop_451', [localStorage.getItem('SHOP_NAME')]),
      deduct_category_id: +localStorage.getItem('SHOPID')
    }
  },
  computed: {
  },
  mounted () {
    console.log('shopsadfas');
    this.$emit('shop', {
      name: this.deduct_category_name,
      value: this.deduct_category_id,
    })
  },
  methods: {}
}
</script>

<style lang='scss' scoped>
</style>
